import styled from 'styled-components'

import { rspTheme } from '../../../styles/rspTheme'

export const CardWrapper = styled.div`
  box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  overflow: hidden;
  max-width: 374px;
`

export const ImageBox = styled.div`
  height: 50%;
  background-color: ${rspTheme.palette.primary.background};
  margin-bottom: 12px;

  .gatsby-image-wrapper {
    max-height: 140px;
    width: 100%;

    img {
      width: 100%;
    }
  }
`

export const ContentBox = styled.div`
  padding: 12px 12px 16px;
  flex-grow: 1;

  .cardBody {
    color: ${rspTheme.palette.text.primary};
    font-size: 1.3rem;
    font-weight: 600;
    letter-spacing: -0.2px;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .cardShort {
    color: ${rspTheme.palette.text.primary};
    font-size: 1.3rem;
    font-weight: 400;
    letter-spacing: -0.2px;
    line-height: 1.5;
    margin-bottom: 16px;
  }
`
